import { render } from "./Dashboard.vue?vue&type=template&id=2e8006e4"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render

export default script